import React from 'react';
import ReactTable from 'components/ReactTable';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

const WhsManagementGrid = ({ data, gridCriteria, loading, actions, onGridCriteriaChanged }) => {
  const onDateChange = (e) => {
    gridCriteria.asOfDate = e;
    onGridCriteriaChanged(gridCriteria);
  };

  return (<div className="container">
    <div className="panel-header">
      <div className="panel-title">Withholding Statements
        { gridCriteria.activeTab === 0 && <div id="as-of-date" className="as-of-date-panel"><label className="form-label">as of:</label>
          <DatePicker
            selected={ gridCriteria.asOfDate }
            fixedHeight
            showMonthDropdown
            placeholderText="Select date"
            popperPlacement="bottom-start"
            popperModifiers={ {
              preventOverflow: {
                enabled: true,
                escapeWithReference: true,
                boundariesElement: 'viewport'
              }
            } }
            autoComplete="off"
            isClearable
            showYearDropdown
            dropdownMode="select"
            className="form-input"
            dateFormat="MMM dd yyyy"
            onChange={ e => onDateChange(e) }
          /></div> }
      </div>
    </div>
    <div className="whs-management-content" id="whs-management-table">
      <ReactTable
        data={ data }
        gridCriteria={ gridCriteria }
        loading={ loading }
        actions={ actions }
        collapseHeight
        enablePagination
        initialLoaded
        canPreviousPage
        canNextPage
        onGridCriteriaChanged={ onGridCriteriaChanged }
        pendingRowLastColumn="whsName"
      />
    </div>
  </div>);
};

WhsManagementGrid.propTypes = {
  gridCriteria: PropTypes.shape().isRequired,
  loading: PropTypes.bool.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape()),
  actions: PropTypes.shape().isRequired,
  onGridCriteriaChanged: PropTypes.func.isRequired
};

WhsManagementGrid.defaultProps = {
  data: []
};

export default WhsManagementGrid;
